module.exports = __webpack_public_path__ + "static/img/personal-storage-box_256.e536e42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personal-storage-box_256.png
// module id = hOk4
// module chunks = 0